import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, inject, AfterViewInit, ViewChild, ElementRef, AfterViewChecked, OnDestroy } from '@angular/core';
import { GeminiService } from 'src/app/services/gemini.service';
import { MatDialogRef } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-geminichat',
  templateUrl: './geminichat.component.html',
  styleUrls: ['./geminichat.component.scss']
})
export class GeminichatComponent implements AfterViewInit, AfterViewChecked, OnDestroy{

  sanitizedUrl: string = '';

  url = '';

  title = 'Geminiapp';
  promt: string = '';
  geminiService: GeminiService = inject(GeminiService);
  loading: boolean = false;
  @ViewChild('messageContainer') private messageContainer: ElementRef;
  chatHistory: any[] = [];

  constructor(public dialogRef: MatDialogRef<GeminichatComponent>, private clipboard: Clipboard, private router: Router) {
    this.geminiService.getMessageHistory().subscribe((res) => {
      if (res) {
        this.chatHistory.push(res);
      }
      this.scrollToBottom();
    });
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }

  ngAfterViewInit() {
    this.scrollToBottom();
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    if (this.messageContainer && this.messageContainer.nativeElement) {
      try {
        this.messageContainer.nativeElement.scrollTop = this.messageContainer.nativeElement.scrollHeight;
      } catch (err) {
        console.error('Scroll to bottom failed', err);
      }
    }
  }

  async sendData() {
    if (this.promt) {
      this.loading = true;
      const data = this.promt;
      await this.geminiService.generateText(this.promt);
      this.promt = '';
      this.loading = false;
      this.scrollToBottom();
    }
  }

  formatText(text: string) {
    return text;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  copyMessage(item: any): void {
    this.clipboard.copy(item.message);
    item.copied = true;
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
